JS.require('jQuery', function($) {
  $('<style type="text/css">' + '</style>').appendTo('head');
});

var UIEditLock = new JS.Class({
  initialize: function(selector, options) {
    this.expireTime = parseInt($(selector).attr('data-expireTime'));
    this.loadTime = parseInt($(selector).attr('data-loadTime'));
    this.haveLock = $(selector).attr('data-haveLock') == 'true';
    this.lockOwnerLink = $(selector).attr('data-lockOwnerLink');

    this.selector = $(selector);

    this.startTime = Math.floor(new Date().getTime() / 1000);

    this.updateLock();
    setInterval(this.method('updateLock'), 15000);
  },

  updateLock: function() {
    var content = $('<div class="alert alert-block"></div>');

    var lockDuration = this.expireTime - this.loadTime;

    var localNow = Math.floor(new Date().getTime() / 1000);

    var localLockStart = this.startTime;
    var localLockEnd = this.startTime + lockDuration;

    var localTimeLeft = localLockEnd - localNow;

    if (this.haveLock) {
      this.selector.parent().hide();
    } else {
      if (localTimeLeft > 0) {
        content.addClass('alert-warning');
        content.html(
          this.lockOwnerLink +
            ' has a lock on this page for <b></b>. Saving the page may create a conflict with their changes.'
        );
        var timeLeft = content.find('b');
        timeLeft.html(this.durationAsText(localTimeLeft));
      } else {
        content.addClass('alert-warning');
        content.html(
          this.lockOwnerLink +
            ' may still have a lock on this page. Saving the page may create a conflict with their changes.'
        );
      }
    }

    this.selector.html('');
    this.selector.append(content);
  },

  durationAsText: function(seconds) {
    var minutes = Math.round(seconds / 60);
    var hours, days, months, years;

    var text = minutes + ' minutes';

    if (minutes >= 60) {
      hours = Math.round(minutes / 60);
      text = hours + ' hours';
    }
    if (hours >= 24) {
      days = Math.round(hours / 24);
      text = days + ' days';
    }
    if (days >= 365 / 12) {
      months = Math.round(days / (365 / 12));
      text = months + ' months';
    }
    if (days > 365) {
      years = Math.round(days / 365);
      text = years + ' years';
    }

    // "moments" ago
    if (minutes == 0) {
      text = 'moments';
    }

    return text;
  },
});
